import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function Preloader() {
  const [show, setShow] = useState(() => !sessionStorage.getItem("skz_splash_seen"));

  useEffect(() => {
    if (!show) return;
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => {
      sessionStorage.setItem("skz_splash_seen", "1");
      setShow(false);
    }, 1900);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = "";
    };
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 z-[100] grid place-items-center bg-[#f7f9fa]"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] } }}
          data-testid="preloader"
        >
          <div className="flex flex-col items-center">
            <motion.div
              initial={{ scale: 0, rotate: -20, opacity: 0 }}
              animate={{ scale: 1, rotate: 0, opacity: 1 }}
              transition={{ type: "spring", stiffness: 200, damping: 14 }}
              className="flex items-center gap-3"
            >
              <span className="w-16 h-16 rounded-full overflow-hidden ring-2 ring-black/5 bg-white grid place-items-center shadow-[0_10px_30px_rgba(27,25,168,0.2)]">
                <img src="/logo1.jpg" alt="Study in KZ" className="w-full h-full object-contain" />
              </span>
              <motion.span
                initial={{ opacity: 0, x: -12 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.35, duration: 0.5 }}
                className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-[#1a1a1a]"
              >
                Study in <span className="text-[#1B19A8]">KZ</span>
              </motion.span>
            </motion.div>

            <div className="mt-8 h-1 w-40 rounded-full bg-black/10 overflow-hidden">
              <motion.div
                initial={{ width: "0%" }}
                animate={{ width: "100%" }}
                transition={{ duration: 1.6, ease: [0.4, 0, 0.2, 1] }}
                className="h-full bg-[#1B19A8]"
              />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
